<script setup>
defineProps({
  value: {
    type: String,
  },
  forInput: {
    type: String,
  }
});
</script>

<template>
  <label class="mod-form-label" :for="forInput">
    <span v-if="value">{{ value }}</span>
    <span v-else><slot/></span>
  </label>
</template>
<style lang="postcss">
.mod-form-label {
  @apply block text-base font-semibold dark:text-white leading-[20px];
}
</style>
